import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Trophy01 = function Trophy01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 15c-3.3137 0-6-2.6863-6-6V3.4444c0-.4138 0-.6207.0603-.7864a1 1 0 0 1 .5977-.5977C6.8237 2 7.0306 2 7.4444 2h9.1112c.4138 0 .6207 0 .7864.0603a1 1 0 0 1 .5977.5977C18 2.8237 18 3.0306 18 3.4444V9c0 3.3137-2.6863 6-6 6m0 0v3m6-14h2.5c.4659 0 .6989 0 .8827.0761.245.1015.4397.2962.5412.5412C22 4.8011 22 5.0341 22 5.5V6c0 .93 0 1.395-.1022 1.7765a3 3 0 0 1-2.1213 2.1213C19.395 10 18.93 10 18 10M6 4H3.5c-.466 0-.699 0-.8827.0761a1 1 0 0 0-.5412.5412C2 4.8011 2 5.0341 2 5.5V6c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C4.605 10 5.07 10 6 10m1.4444 12h9.1112A.4444.4444 0 0 0 17 21.5556C17 19.5919 15.4081 18 13.4444 18h-2.8888C8.5919 18 7 19.5919 7 21.5556c0 .2454.199.4444.4444.4444"
    })
  }));
};
export default Trophy01;